import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';
import { BookOpen, ArrowLeft } from 'lucide-react';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true); setError(null);
    try {
      await api('/api/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email: email.trim() }) });
      setSubmitted(true);
    } catch (err: any) {
      setError(err?.message || 'Fehler');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-6">
          <BookOpen className="w-10 h-10 text-blue-500" />
          <h1 className="text-3xl font-bold text-white">Hausaufgabenheft</h1>
        </div>

        <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-white mb-1">Passwort vergessen?</h2>
          <p className="text-sm text-gray-400 mb-5">
            Gib deine E-Mail an. Wenn ein Account existiert, bekommst du einen Link zum Zurücksetzen.
          </p>

          {submitted ? (
            <div className="space-y-4">
              <div className="bg-green-500/10 border border-green-500/40 text-green-300 rounded-lg p-4 text-sm">
                Falls <strong className="font-mono">{email}</strong> bei uns registriert ist, haben wir dir gerade
                eine E-Mail mit einem Reset-Link geschickt. Der Link ist 1 Stunde gültig.
                <br /><br />
                Schau ggf. auch im Spam-Ordner nach.
              </div>
              <Link to="/login" className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 text-sm">
                <ArrowLeft className="w-4 h-4" /> Zurück zum Login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-sm text-gray-300 mb-1">E-Mail</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-500"
                  placeholder="du@example.com" autoFocus />
              </div>
              {error && <p className="text-red-400 text-sm">{error}</p>}
              <button type="submit" disabled={busy}
                className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-semibold px-4 py-2 rounded-lg">
                {busy ? 'Sende…' : 'Reset-Link anfordern'}
              </button>
              <div className="flex justify-between text-sm">
                <Link to="/login" className="text-blue-400 hover:text-blue-300 flex items-center gap-1">
                  <ArrowLeft className="w-3 h-3" /> Zurück zum Login
                </Link>
                <Link to="/register" className="text-blue-400 hover:text-blue-300">Noch kein Account?</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
